import { Box, Button, Grid, Stack, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import { capabilities } from '@/content/copy'
import { featureIcons } from '@/lib/icons'
import { colors, fonts } from '@/theme'
import { Section } from '@/components/ui/Section'
import { SectionHeading } from '@/components/ui/SectionHeading'

/** B2B / distributor capabilities — a numbered "dossier" grid (distinct from the manifesto above). */
export function Capabilities() {
  return (
    <Section>
      <SectionHeading eyebrow={capabilities.eyebrow} title={capabilities.title} description={capabilities.lede} />
      <Grid container spacing={0} sx={{ borderTop: `1px solid ${colors.border}`, borderLeft: { md: `1px solid ${colors.border}` } }}>
        {capabilities.items.map((item, i) => {
          const Icon = featureIcons[item.icon]
          return (
            <Grid key={item.title} size={{ xs: 12, sm: 6, md: 4 }}>
              <Box
                sx={{
                  position: 'relative',
                  height: '100%',
                  p: { xs: 3, md: 4 },
                  borderBottom: `1px solid ${colors.border}`,
                  borderRight: { md: `1px solid ${colors.border}` },
                  transition: 'background-color 300ms ease',
                  '&:hover': { bgcolor: colors.surface },
                  '&:hover .cap-rule': { width: 48 },
                  '&:hover .cap-icon': { color: colors.gold },
                }}
              >
                <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 2.5 }}>
                  <Typography sx={{ fontFamily: fonts.display, fontWeight: 600, fontSize: 30, color: 'rgba(212,175,55,0.4)', lineHeight: 1 }}>
                    {String(i + 1).padStart(2, '0')}
                  </Typography>
                  <Box className="cap-icon" sx={{ color: colors.grey, transition: 'color 300ms ease' }}>
                    {Icon && <Icon size={24} />}
                  </Box>
                </Stack>
                <Box className="cap-rule" sx={{ width: 24, height: 2, bgcolor: colors.gold, mb: 2, transition: 'width 350ms cubic-bezier(.2,.8,.2,1)' }} />
                <Typography variant="h6" component="h3" sx={{ mb: 1 }}>
                  {item.title}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  {item.text}
                </Typography>
              </Box>
            </Grid>
          )
        })}
      </Grid>
      <Button variant="contained" component={RouterLink} to="/contact" sx={{ mt: { xs: 6, md: 8 } }}>
        Request a Bulk Inquiry
      </Button>
    </Section>
  )
}
